import moment from 'moment';

const state = {
	dateRange: {
		start: moment().startOf("isoWeek").format("YYYY-MM-DD"),
		end: moment().endOf("isoWeek").format("YYYY-MM-DD")
	},
}

const mutations = {
	'Set_DateRange'(state, dateRange) {
		state.dateRange = dateRange;
	},
}

const actions = {
	setDateRange({ commit }, dateRange) {
		commit('Set_DateRange', dateRange);
	},
}

const getters = {
	dateRange: (state) => {
		return state.dateRange;
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
